import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import TopBar from "@/components/TopBar";
import BottomNav from "@/components/BottomNav";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.items || []); }
    catch (e) { setErr(errMsg(e)); }
  };

  useEffect(() => { load(); }, []);

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); load(); } catch (_e) { /* ignore */ }
  };

  return (
    <div className="app-shell pb-24" data-testid="notifications-page">
      <TopBar
        title={t("notifications")}
        right={
          <button data-testid="mark-all-read" onClick={markAll} className="inline-flex items-center gap-1 h-9 px-3 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold">
            <CheckCheck className="h-3.5 w-3.5" /> {t("markRead")}
          </button>
        }
      />
      <div className="px-5 pt-4 space-y-2">
        {err && <div className="text-sm text-red-600 bg-red-50 rounded-lg p-3">{err}</div>}
        {items.length === 0 && <div className="card-surface p-5 text-sm text-zinc-600">{t("noNotifications")}</div>}
        {items.map((n) => (
          <button
            key={n.id}
            data-testid={`notif-${n.id}`}
            onClick={() => n.link && navigate(n.link)}
            className={`w-full text-start card-surface p-4 flex items-start gap-3 ${n.read ? "" : "border-emerald-200 bg-emerald-50/40"}`}
          >
            <div className={`h-9 w-9 rounded-full grid place-items-center shrink-0 ${n.read ? "bg-zinc-100 text-zinc-500" : "bg-emerald-100 text-emerald-700"}`}>
              <Bell className="h-4 w-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">{n.title}</div>
              <div className="text-xs text-zinc-600 mt-0.5">{n.body}</div>
              <div className="text-[10px] text-zinc-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </div>
            {!n.read && <span className="h-2 w-2 rounded-full bg-emerald-500 mt-2" />}
          </button>
        ))}
      </div>
      <BottomNav />
    </div>
  );
}
